import { useEffect, useRef, useState } from 'react'

// This hook allows having delayed effect of state change

export default (prop: boolean, { only, timeout = 1000 }: { only: boolean; timeout: number }): boolean => {
  const [delayedProp, setProp] = useState(false)
  const timer = useRef<NodeJS.Timeout>()
  useEffect(() => {
    if (typeof only === 'undefined' || only === prop) {
      timer.current = setTimeout(() => setProp(prop), timeout)
    } else {
      setProp(prop)
    }
    return () => {
      clearTimeout(timer.current)
    }
  }, [prop, delayedProp, only, timeout])
  return delayedProp
}
